import { ImAirplane } from "react-icons/im";
import { FaCar } from "react-icons/fa";
import { MdHealthAndSafety } from "react-icons/md";
import { RiHotelLine } from "react-icons/ri";
import { CiPassport1 } from "react-icons/ci";

export default ({value, onClick}) => {

    let Icon;

    switch (value) {
        case 'אעופה':
        case 'טיסה':
            Icon = <ImAirplane className="barMainDocketIcon" />;
            break;
        case 'רכב':
            Icon = <FaCar className="barMainDocketIcon" />
            break;
        case 'ביטוח':
            Icon = <MdHealthAndSafety className="barMainDocketIcon" />
            break;
        case 'מלון':
            Icon = <RiHotelLine className="barMainDocketIcon" />
            break;
        case 'ויזה':
            Icon = <CiPassport1 className="barMainDocketIcon" />
            break;
    }

    return (
        <div onClick={onClick ? () => onClick() : () => {}}>
            <p> {value} </p>
            {Icon}
        </div>
    )
}